import styled from "@emotion/styled";

export const ConfirmationThanksContainer = styled.div(({ theme }) => ({
	backgroundColor: theme.project.colors.backgroundColors.main,
	marginBottom: 16,
	"> div:nth-of-type(2)": {
		padding: "0 24px 24px 24px",
		"div:first-of-type": {
			...theme.project.typography.body.body1,
			marginBottom: 16,
			color: theme.project.colors.fontColors.secondary
		}
	},
	[theme.breakpoints.down("md")]: {
		"> div:nth-of-type(2)": {
			marginTop: 0
		}
	}
}));
